import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import packageJson from '../package.json';

import App from './App';

Sentry.init({
  release: `uysot@${packageJson.version}`,
  dsn: 'https://80db486cf45370fb749a413de2f40615@o4508640350306304.ingest.de.sentry.io/4508646119702609',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.replayIntegration({
      blockAllMedia: false
    })
  ],
  tracePropagationTargets: [import.meta.env.VITE_BASE_URL],
  beforeSend(event, hint) {
    if (window.location.hostname !== 'app.uysot.uz') {
      return null;
    }

    if (
      (hint?.originalException as { stack: string })?.stack &&
      (hint?.originalException as { stack: string })?.stack?.includes('node_modules')
    ) {
      return null;
    }

    if (hint && hint?.originalException && (hint?.originalException as any)?.isAxiosError) {
      const status = (hint?.originalException as any)?.response?.status;

      if (status === 400 || status === 401) {
        return null;
      }

      if ((hint?.originalException as any)?.response && (hint?.originalException as any)?.response?.data) {
        const contexts = {
          ...(event?.contexts || {})
        };

        contexts.errorResponse = {
          data: (hint?.originalException as any)?.response?.data,
          payload: (hint?.originalException as any)?.request?.payload,
          body: (hint?.originalException as any)?.request?.body
        };

        event.contexts = contexts;
      }
    }

    return event;
  },
  tracesSampleRate: 1.0,
  denyUrls: [/node_modules/],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    /AbortError/,
    /FirebaseError/,
    /Network Error/,
    /NotAllowedError/,
    /InvalidStateError/,
    'Non-Error promise rejection captured',
    'Object captured as promise rejection with keys',
    'AbortError: The play() request was interrupted by a call to pause()'
  ]
});

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App tab="home" />);
